export default [{
	type: "3% Intellect",
	classes: [8], // Mage
	icon: "intellect.jpg"
}, {
	type: "5% Attack Power",
	classes: [1], // Warrior
	icon: "attack_power.jpg"
}, {
	type: "5% Stamina",
	classes: [5], // Priest
	icon: "stamina.jpg"
}, {
	type: "5% Physical Damage",
	classes: [10], // Monk
	icon: "physical_damage.jpg"
}, {
	type: "3% Magic Damage",
	classes: [12], // DH
	icon: "magic_damage.jpg"
}, {
	type: "3% Damage Reduction",
	classes: [2], // Paladin
	icon: "damage_reduction.jpg"
}, {
	type: "3% Versatility",
	classes: [11], // Druid
	icon: "versatility.jpg"
}, {
	type: "Movement Speed",
	classes: [13], // Evoker
	icon: "movement_speed.jpg"
}, {
	type: "Skyfury",
	classes: [7], // Shaman
	icon: "skyfury.jpg"
}];